import { v4 as uuid } from "uuid";

import { IBadgeResource } from "../../badges";
import { EntityTypes } from "../../EntityTypes";
import { ISkillResource } from "../../skills";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapOrderedRelationAsIRIs, RelationalValue } from "../../utils/filters";
import { ISkillBlock } from "../types";

export type ISkillBlockCreateMutationParameters = {
    title: string;
    shortTitle: string;
    rncpId?: string;
    skills: RelationalValue<ISkillResource>[];
    badges?: RelationalValue<IBadgeResource>[];
    uuid?: string;
};

export type ISkillBlockCreateMutationResult = ISkillBlock;

export const skillBlockCreateMutation: IApiMutationFunction<ISkillBlockCreateMutationParameters> = ({
    uuid: providedUuid,
    title,
    shortTitle,
    rncpId,
    skills,
    badges,
}) => {
    return {
        method: "POST",
        url: "/skill_blocks",
        data: {
            title,
            shortTitle,
            rncpId,
            skills: mapOrderedRelationAsIRIs(EntityTypes.SKILL, skills),
            badges: mapOrderedRelationAsIRIs(EntityTypes.BADGE, badges),
            uuid: providedUuid ?? uuid(),
        },
    };
};

export const useSkillBlockCreateMutation = createApiMutationHook<
    ISkillBlockCreateMutationParameters,
    ISkillBlockCreateMutationResult
>(skillBlockCreateMutation);
